<template>
    <div class="reference">
        <!-- <el-link to="{name:'Api'}" class="item" :underline="false">参考文档</el-link>
        <el-link class="item" :underline="false">在线工具</el-link>
        <el-link class="item" :underline="false">技术论坛</el-link> -->
        <el-link to="{name:'Api'}" class="item" :underline="false">接口协议</el-link>
    </div>
    <div class="docs">

        <router-view></router-view>
    </div>
</template>
  
<script lang="ts" setup>
</script>

<style lang="scss" scoped>
.reference {
    margin-left: auto;

    .item {
        margin: auto 15px;
        font-size: 13px;
        font-weight: normal;
    }
}

.docs {
    padding: 20px;
}
</style>